//* 将物种id转物种名称
export default (species: string | number) => {
    switch (species?.toString()) {
        case "9606":
            return "human";
        case "10090":
            return "mouse";
        case "10116":
            return "rat";
        default:
            return "";
    }
};
